export const tuple = <T extends any[]>(...args: T): T => args;
